(function(){
  'use strict';
  var ROOT_SELECTOR='[data-hv-product-reviews]';
  var MAX_FILES=3;
  var MAX_ORIGINAL_BYTES=10*1024*1024;
  var TARGET_BYTES=7000;
  var MAX_SIDE=260;

  function lang(){return (document.documentElement.lang||'ar').toLowerCase();}
  function msg(key){
    var l=lang();
    var t={
      tooMany:{fr:'Vous pouvez ajouter jusqu’à 3 photos.',en:'You can add up to 3 photos.',ar:'يمكنكِ إضافة حتى 3 صور فقط.'},
      badType:{fr:'Utilisez uniquement JPG, PNG ou WEBP.',en:'Use JPG, PNG or WEBP images only.',ar:'استخدمي صور JPG أو PNG أو WEBP فقط.'},
      tooLarge:{fr:'Chaque photo doit faire moins de 10 Mo.',en:'Each photo must be under 10 MB.',ar:'يجب أن يكون حجم كل صورة أقل من 10 ميجابايت.'},
      preparing:{fr:'Préparation des photos…',en:'Preparing photos…',ar:'جاري تجهيز الصور…'},
      imageError:{fr:'Une photo n’a pas pu être préparée. Essayez une autre image.',en:'A photo could not be prepared. Try another image.',ar:'تعذّر تجهيز إحدى الصور. يُرجى اختيار صورة أخرى.'},
      sending:{fr:'Publication de votre avis…',en:'Publishing your review…',ar:'جاري نشر تقييمك…'},
      photoAlt:{fr:'Photo jointe à l’avis client',en:'Customer review photo',ar:'صورة مرفقة بتقييم العميل'}
    };
    var row=t[key]||{};
    return l.indexOf('fr')===0?row.fr:(l.indexOf('en')===0?row.en:row.ar);
  }

  function showStatus(root,text,isError){
    var el=root.querySelector('[data-hv-status]');
    if(!el)return;
    el.textContent=text||'';
    el.className='hv-pr__status'+(text?' is-visible '+(isError?'is-error':'is-info'):'');
  }

  function hideTechnicalEmail(root){
    var email=root.querySelector('input[name="comment[email]"]');
    if(!email)return;
    var form=email.form;
    var group=email.closest('div');
    email.type='hidden';
    email.value='anonymous@herbalvitaly.com';
    email.removeAttribute('required');
    email.removeAttribute('autocomplete');
    email.removeAttribute('id');
    if(form&&group&&group.parentNode){form.insertBefore(email,group);group.remove();}
  }

  function renderEmbeddedImages(root){
    root.querySelectorAll('.hv-pr__body').forEach(function(body){
      if(body.dataset.hvImagesDecoded==='1')return;
      body.dataset.hvImagesDecoded='1';
      var text=body.textContent||'';
      var re=/\[HVIMG:(data:image\/jpeg;base64,[A-Za-z0-9+/=]+)\]/g;
      var matches=[];
      var match;
      while((match=re.exec(text))!==null&&matches.length<MAX_FILES){matches.push(match[1]);}
      if(!matches.length)return;
      body.textContent=text.replace(/\s*\[HVIMG:data:image\/jpeg;base64,[A-Za-z0-9+/=]+\]/g,'').trim();
      var photos=document.createElement('div');
      photos.className='hv-pr__photos';
      matches.forEach(function(src){
        var a=document.createElement('a');
        a.className='hv-pr__photo';
        a.href=src;
        a.target='_blank';
        a.rel='noopener';
        var img=document.createElement('img');
        img.src=src;
        img.loading='lazy';
        img.alt=msg('photoAlt');
        a.appendChild(img);
        photos.appendChild(a);
      });
      var card=body.closest('.hv-pr__card');
      (card||body.parentNode).appendChild(photos);
    });
  }

  function loadImage(file){
    return new Promise(function(resolve,reject){
      var url=URL.createObjectURL(file);
      var image=new Image();
      image.onload=function(){URL.revokeObjectURL(url);resolve(image);};
      image.onerror=function(){URL.revokeObjectURL(url);reject(new Error('IMAGE_DECODE_FAILED'));};
      image.src=url;
    });
  }

  function canvasBlob(canvas,quality){
    return new Promise(function(resolve){canvas.toBlob(resolve,'image/jpeg',quality);});
  }

  function blobToDataUrl(blob){
    return new Promise(function(resolve,reject){
      var reader=new FileReader();
      reader.onload=function(){resolve(String(reader.result||''));};
      reader.onerror=reject;
      reader.readAsDataURL(blob);
    });
  }

  async function compress(file){
    if(!/^image\/(jpeg|png|webp)$/.test(file.type))throw new Error('BAD_TYPE');
    if(file.size>MAX_ORIGINAL_BYTES)throw new Error('TOO_LARGE');
    var image=await loadImage(file);
    var longest=Math.max(image.naturalWidth,image.naturalHeight);
    var base=Math.min(1,MAX_SIDE/longest);
    var lastBlob=null;
    for(var attempt=0;attempt<9;attempt+=1){
      var scale=base*Math.pow(0.82,attempt);
      var canvas=document.createElement('canvas');
      canvas.width=Math.max(1,Math.round(image.naturalWidth*scale));
      canvas.height=Math.max(1,Math.round(image.naturalHeight*scale));
      var ctx=canvas.getContext('2d');
      if(!ctx)throw new Error('CANVAS_FAILED');
      ctx.fillStyle='#fff';
      ctx.fillRect(0,0,canvas.width,canvas.height);
      ctx.drawImage(image,0,0,canvas.width,canvas.height);
      var quality=Math.max(0.28,0.66-attempt*0.05);
      lastBlob=await canvasBlob(canvas,quality);
      if(lastBlob&&lastBlob.size<=TARGET_BYTES)return blobToDataUrl(lastBlob);
    }
    if(lastBlob&&lastBlob.size<=12000)return blobToDataUrl(lastBlob);
    throw new Error('COMPRESS_FAILED');
  }

  function validateFiles(root,input){
    var files=Array.prototype.slice.call((input&&input.files)||[]);
    if(files.length>MAX_FILES){showStatus(root,msg('tooMany'),true);return false;}
    for(var i=0;i<files.length;i+=1){
      if(!/^image\/(jpeg|png|webp)$/.test(files[i].type)){showStatus(root,msg('badType'),true);return false;}
      if(files[i].size>MAX_ORIGINAL_BYTES){showStatus(root,msg('tooLarge'),true);return false;}
    }
    return true;
  }

  function init(root){
    if(!root||root.dataset.hvImageFix==='1')return;
    root.dataset.hvImageFix='1';
    hideTechnicalEmail(root);
    renderEmbeddedImages(root);
    var form=root.querySelector('form');
    if(!form)return;
    var input=root.querySelector('[data-hv-photo-input]');
    var submit=root.querySelector('[data-hv-submit]');
    var originalSubmit=submit?submit.textContent:'';

    form.addEventListener('submit',function(event){
      if(form.dataset.hvDirectSubmit==='1')return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if(!validateFiles(root,input))return;

      (async function(){
        var rating=form.querySelector('input[name="hv_rating"]:checked');
        var body=form.querySelector('textarea[name="comment[body]"]');
        if(!rating||!body)return;
        var clean=body.value
          .replace(/^\[HV[1-5]\]\s*/,'')
          .replace(/\s*\[HVMEDIA:[^\]]+\]/g,'')
          .replace(/\s*\[HVIMG:data:image\/jpeg;base64,[A-Za-z0-9+/=]+\]/g,'')
          .trim();
        var files=Array.prototype.slice.call((input&&input.files)||[]);
        try{
          var markers='';
          if(files.length){
            showStatus(root,msg('preparing'),false);
            if(submit){submit.disabled=true;submit.textContent=msg('preparing');}
            for(var i=0;i<files.length;i+=1){
              var dataUrl=await compress(files[i]);
              markers+=' [HVIMG:'+dataUrl+']';
            }
          }
          body.removeAttribute('maxlength');
          body.value='[HV'+rating.value+'] '+clean+markers;
          hideTechnicalEmail(root);
          form.dataset.hvDirectSubmit='1';
          showStatus(root,msg('sending'),false);
          if(submit){submit.disabled=true;submit.textContent=msg('sending');}
          HTMLFormElement.prototype.submit.call(form);
        }catch(error){
          form.dataset.hvDirectSubmit='0';
          if(submit){submit.disabled=false;submit.textContent=originalSubmit;}
          showStatus(root,msg('imageError'),true);
        }
      })();
    },true);
  }

  function initAll(scope){
    var base=scope&&scope.querySelectorAll?scope:document;
    Array.prototype.forEach.call(base.querySelectorAll(ROOT_SELECTOR),init);
    if(base.matches&&base.matches(ROOT_SELECTOR))init(base);
  }

  function boot(){initAll(document);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
})();
